module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAOCAYAAAFoTx1HAAAAAXNSR0IArs4c6QAAAJtJREFUKBW9UjESgDAIs56jk/7Dt/kU3+Y/2sldSb1UQK2b3NUACVC8No3YtGwRWDPR7DjQtI9CsoHOTWrqAmgtVU1T9kl6NG1UlXWlKrKSDK6GTQcmiOvch1Y+IxMey0woQRLhFxKBtyr5+hPQPpO+nV9J34Nadn1clSKHSRpd22OKnvQVV5d0k0z4f2Gn5uOdDXpPcC4+36LkD03lSvt24wa4AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/ic_delete_blue.png
// module id = 150
// module chunks = 170